exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.filter-container[data-v-77a2aced] {\r\n    padding: 20px;\n}\n.filter-item[data-v-77a2aced] {\r\n    margin-left: 10px;\n}\r\n", ""]);

// exports
